import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

export default function directCustomerFinancialsColumnSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = `${order.id}+${index}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let importantData = null;
            let columnValue = null;
            let isDisabled = false;

            if (columnId === "orderId" && order.orderId) {
                columnValue = order.orderId;
            }
            else if (column.id === "hpInvoiceDate") {
                columnValue = getDateWithSpecificFormat(order?.hpInvoiceDate) || "";
            }
            else if (columnId === "s4OrderNumber") {
                columnValue = order.s4OrderNumber || "";
            }
            else if (columnId === "orderType") {
                columnValue = getOrderTypeText(order.orderType) || "";
            }
            else if (columnId === "collectionDate") {
                columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
            }
            else if (columnId === "legalEntityName") {
                columnValue = order.legalEntity || "";
            }
            else if (columnId === "collectionCity") {
                columnValue = order.collectionCity || "";
            }
            else if (columnId === "paymentType") {
                columnValue = order.paymentType ? getStatusDescriptionFromStatusValue(order.paymentType) : "";
            }
            else if (columnId === "lineType") {
                let lineTypeValue = '';
                if (order.lineType === "hardware") {
                    lineTypeValue = 'Hardware Line';
                } else if (order.lineType === "service") {
                    lineTypeValue = 'Service Line';
                } else if (order.lineType === "general") {
                    lineTypeValue = 'General Line';
                } else if (order.lineType) {
                    lineTypeValue = order.lineType;
                }
                columnValue = lineTypeValue;
            }
            else if (columnId === "amount") {
                columnValue = order.customerAmount == null || order.customerAmount == undefined ? 0 : order.customerAmount;
                importantData = order.customerAmount < 0 ? "NegativeAmount" : "";
            }
            else if (column.id === "currencyCode") {
                columnValue = order.currencyCode || "";
            }
            else if (columnId === "paymentStatus") {
                columnValue = getStatusDescriptionFromStatusValue(order.paymentStatus) || "";
            }
            else if (columnDataType === "globalInvoice") {
                if (column.id === "invoiceAndPaymentInstruction") {
                    columnValue = "download"
                    if (order.customerAmount === 0) {
                        columnValue = "";
                        columnDataType = "string";
                    }
                    else {
                        columnValue = "download"
                    }
                    if (order.paymentType === "HP Credit Value" && order.customerAmount > 0) {
                        isDisabled = true;
                    }
                    // Fix for SUPP2-6045
                    else if (order.paymentType === "HP Payment + HP2B" && order.customerAmount === 0 && order.lineType === 'hardware') {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                    else if (order.paymentType === 'No Customer Payment') {
                        isDisabled = true;
                    }
                }
            }
            else if (order.paymentType === "HP Payment + CMO") {
                if (columnId === "customerInvoiceDate") {
                    columnDataType = "string"
                    columnValue = order.paymentDate || "";
                }
                else if (column.id === "hpPONo") {
                    columnDataType = "string"
                    columnValue = order.hpPONo || "";
                    isDisabled = true;
                }
                else if (column.id === "customerInvoiceNo") {
                    if (order.lineType === "service" || order.isCustomerInvoiceNumberDisabled) {
                        columnDataType = "string"
                        columnValue = order.customerInvoiceNo || "";
                        isDisabled = true;
                    } else {
                        columnValue = { defaultValue: order.customerInvoiceNo || "", ...column.data };
                    }
                }
                else if (column.id === "customerPONo") {
                    if (order.lineType === "hardware" || order.isCustomerPoNoDisabled) {
                        columnDataType = "string"
                        columnValue = order.customerPONo || "";
                        isDisabled = true;
                    }
                    else {
                        columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                    }

                    if (order.lineType === "harware" && order.paymentType === "DRV Dual Payment") {
                        isDisabled = true;
                    } else if (order.lineType === "service" && order.paymentType === "DRV Dual Payment") {
                        isDisabled = false;
                    }
                }
                else if (column.id === "hpInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.hpInvoiceNo || "";
                    isDisabled = true;
                }
            }
            else if (order.paymentType === "DRV Net Payment" || order.paymentType === "HP Credit Value") {
                if (columnId === "customerInvoiceDate") {
                    if (order.paymentType === "HP Credit Value") {
                        columnValue = { defaultValue: order.paymentDate || "", ...column.data };
                    } else {
                        columnDataType = "string"
                        columnValue = order.paymentDate || "";
                    }
                }
                else if (column.id === "hpPONo") {
                    columnDataType = "string"
                    columnValue = order.hpPONo || "";
                    isDisabled = true;
                }
                else if (column.id === "customerInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.customerInvoiceNo || "";
                    isDisabled = true;
                }
                else if (column.id === "customerPONo") {
                    if (order.paymentType === "DRV Net Payment" || order.customerAmount >= 0) {
                        columnDataType = "string"
                        columnValue = order.customerPONo || "";
                        isDisabled = true;
                    } else {
                        columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                    }
                }
                else if (column.id === "hpInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.hpInvoiceNo || "";
                    isDisabled = true;
                }
            }
            else if (order.paymentType === "HP Payment + HP2B") {
                if (columnId === "customerInvoiceDate") {
                    columnDataType = "string"
                    columnValue = order.paymentDate || "";
                }
                else if (column.id === "hpPONo") {
                    columnDataType = "string"
                    columnValue = order.hpPONo || "";
                    isDisabled = true;
                    // Fix for SUPP2-6045
                    if (order.customerAmount === 0 && order.lineType === 'hardware') {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                }
                else if (column.id === "customerInvoiceNo") {
                    if (order.lineType === "service" || order.isCustomerInvoiceNumberDisabled) {
                        columnDataType = "string"
                        columnValue = order.customerInvoiceNo || "";
                        isDisabled = true;
                    } else {
                        columnValue = { defaultValue: order.customerInvoiceNo || "", ...column.data };
                    }
                    // Fix for SUPP2-6045
                    if (order.customerAmount === 0 && order.lineType === 'hardware') {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                }
                else if (column.id === "customerPONo") {
                    if (order.lineType === "service") {
                        if (order.isCustomerPoNoDisabled) {
                            columnDataType = "string"
                            columnValue = order.customerPONo || "";
                            isDisabled = true;
                        }
                        else {
                            columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                        }
                    } else {
                        columnDataType = "string"
                        columnValue = order.customerPONo || "";
                        isDisabled = true;
                    }
                    // Fix for SUPP2-6045
                    if (order.customerAmount === 0 && order.lineType === 'hardware') {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                }
                else if (column.id === "hpInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.hpInvoiceNo || "";
                    isDisabled = true;
                    // Fix for SUPP2-6045
                    if (order.customerAmount === 0 && order.lineType === 'hardware') {
                        columnValue = "";
                        columnDataType = "string";
                        isDisabled = true;
                    }
                }
            }
            else if (order.paymentType === "HP Net payment") {
                if (columnId === "customerInvoiceDate") {
                    columnValue = { defaultValue: order.paymentDate || "", ...column.data };
                }
                else if (order.customerAmount >= 0) {
                    if (column.id === "hpPONo") {
                        columnDataType = "string"
                        columnValue = order.hpPONo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "hpInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.hpInvoiceNo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerInvoiceNo") {
                        columnValue = { defaultValue: order.customerInvoiceNo || "", ...column.data };
                    }
                    else if (column.id === "customerPONo") {
                        columnDataType = "string"
                        columnValue = order.customerPONo || "";
                        isDisabled = true;
                    }
                } else {
                    if (column.id === "hpPONo") {
                        columnDataType = "string"
                        columnValue = order.hpPONo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.customerInvoiceNo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerPONo") {
                        columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                    }
                    else if (column.id === "hpInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.hpInvoiceNo || "";
                        isDisabled = true;
                    }
                }
            }
            else if (order.paymentType === "DRV Dual Payment") {
                if (columnId === "customerInvoiceDate") {
                    columnValue = { defaultValue: order.paymentDate || "", ...column.data };
                }
                else if (order.customerAmount >= 0) {
                    if (column.id === "hpPONo") {
                        columnDataType = "string"
                        columnValue = order.hpPONo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "hpInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.hpInvoiceNo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerInvoiceNo") {
                        columnValue = { defaultValue: order.customerInvoiceNo || "", ...column.data };
                        isDisabled = true;
                        if (order.lineType === "service") {
                            isDisabled = false;
                        }
                    }
                    else if (column.id === "customerPONo") {
                        columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                        isDisabled = true;
                        if (order.lineType === "hardware") {
                            isDisabled = false;
                        }
                    }
                } else {
                    if (column.id === "hpPONo") {
                        columnDataType = "string"
                        columnValue = order.hpPONo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.customerInvoiceNo || "";
                        isDisabled = true;
                    }
                    else if (column.id === "customerPONo") {
                        columnValue = { defaultValue: order.customerPONo || "", ...column.data };
                    }
                    else if (column.id === "hpInvoiceNo") {
                        columnDataType = "string"
                        columnValue = order.hpInvoiceNo || "";
                        isDisabled = true;
                    }
                }
            }
            else {
                if (columnId === "customerInvoiceDate") {
                    columnDataType = "string"
                    columnValue = order.paymentDate || "";
                }
                else if (column.id === "hpPONo") {
                    columnDataType = "string"
                    columnValue = order.hpPONo || "";
                    isDisabled = true;
                }
                else if (column.id === "customerInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.customerInvoiceNo || "";
                    isDisabled = true;
                }
                else if (column.id === "customerPONo") {
                    columnDataType = "string"
                    columnValue = order.customerPONo || "";
                    isDisabled = true;
                }
                else if (column.id === "hpInvoiceNo") {
                    columnDataType = "string"
                    columnValue = order.hpInvoiceNo || "";
                    isDisabled = true;
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    importantData: importantData,
                    disabledCell: isDisabled,
                    isGlobal: order.paymentStatus === "SERVICE_PAYMENT_TO_HP_PENDING" && order.paymentType === "HP Payment + HP2B" ? true : false,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, order.orderId, columnId, index, order.lineType) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
